import React from 'react';
import PropTypes from 'prop-types';
import Comment from './Comment';
import { Link } from 'react-router-dom';

const PostCaption = ({ username }) => {
  return (
    <div className="post-caption">
      <span>
        <span className="transparent-text">Hosted by </span>
      <Link to={`/user/${username}`}>
          <span className="comment-author">{username}</span>
      </Link>
      </span>
    </div>
  );
};

PostCaption.propTypes = {
  username: PropTypes.string.isRequired,
};


export default PostCaption;
